const LOGO_SRC = `${process.env.PUBLIC_URL || ''}/brand/hammer-mark.png`;

/**
 * HAMMER wordmark: the gym's eagle mark (a decorative image — the name next
 * to it is the accessible text) plus "HAMMER" in the tall condensed display
 * face with a small "Gym" tag. Purely presentational; callers decide the
 * semantic wrapper (an h1 on the login, plain text in the sidebar).
 */
export function Brand({ tone = 'dark', size = 'md' }) {
  return (
    <span className={`gym-brand gym-brand--${tone} gym-brand--${size}`}>
      <img className="gym-brand__logo" src={LOGO_SRC} alt="" width="256" height="256" />
      <span className="gym-brand__text">
        <span className="gym-brand__name">HAMMER</span>{' '}
        <span className="gym-brand__tag">Gym</span>
      </span>
    </span>
  );
}
